import { ChatServiceType, IChatMessage } from '@nimbus-global/features/chat/models/chat.model';

/**
 * Builds the comparator used to order chat messages for display. WebChat sorts by timestamp
 * (with index as a tie-break and a NaN guard for invalid dates); all other channels keep the
 * server-authoritative index order.
 */
export function getChatMessageComparator(chatServiceType: ChatServiceType): (a: IChatMessage, b: IChatMessage) => number {
  if (chatServiceType !== ChatServiceType.WebChat) {
    return (a, b) => a.index - b.index;
  }
  return (a, b) => {
    const dateDiff = new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
    if (Number.isNaN(dateDiff) || dateDiff === 0) {
      return a.index - b.index;
    }
    return dateDiff;
  };
}
